// extracted by mini-css-extract-plugin
module.exports = {"container":"_2MalLdM0z7F_M_OzIl2LWQ","visible":"_3AgXB_Wesn53tJfyNVFbp6","cancelBtn":"_33A4AFcQS4II5GzYYobN3M","icon":"_2stgQxjgpC0lMd4uBYE9zY","saveBtn":"_1Narphq8VVqEmisZ_uon5o"};